<template>
  <div class="w-full px-6 py-4">
    <div class="flex space-x-4 mb-6">
      <OFieldGroup col reverse class="w-full" :label="$t('components.service.edit.reminders.title')" :info="$t('components.service.edit.reminders.info')">
        <ToggleField v-model="_service.nextReservationReminderEnabled" />
      </OFieldGroup>
    </div>

    <div class="flex space-x-4 mb-4">
      <OFieldGroup class="w-full" :label="$t('components.service.edit.reminders.days')" :info="$t('components.service.edit.reminders.daysInfo')">
        <NumberField v-model="_service.nextReservationReminderDays" :disabled="!_service.nextReservationReminderEnabled" />
      </OFieldGroup>
    </div>

    <div class="flex space-x-4 mb-4">
      <OFieldGroup class="w-full" :label="$t('components.service.edit.reminders.mode')" :info="$t('components.service.edit.reminders.modeInfo')">
        <SelectField v-model="_service.reviewReminderMode" :options="serviceReviewReminderModeOptions" />
      </OFieldGroup>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  OFieldGroup
} from '@/components/elements'

import {
  SelectField,
  NumberField,
  ToggleField,
} from '@/components/fields'

import { type Service, ServiceReviewReminderMode, ServiceReviewReminderModeLabels } from '~/_api/models/service'

// Use Nuxt app composables
const { $i18n } = useNuxtApp() as any

// Model bindings
const _service = defineModel<Service>('service')

const serviceReviewReminderModeOptions = [
  { label: $i18n.t(ServiceReviewReminderModeLabels[ServiceReviewReminderMode.none]), value: ServiceReviewReminderMode.none },
  { label: $i18n.t(ServiceReviewReminderModeLabels[ServiceReviewReminderMode.every]), value: ServiceReviewReminderMode.every },
  { label: $i18n.t(ServiceReviewReminderModeLabels[ServiceReviewReminderMode.one]), value: ServiceReviewReminderMode.one },
]
</script>
